import { useEffect, useRef } from 'react';

export type BeatFn = (index: number, duration: number) => Promise<void>;
export interface UseBeatOptions {
  enabled?: boolean;
  onBeat: BeatFn;
  interval: number;
  type?: 'delay' | 'rate';
}
export default function useBeat(options: UseBeatOptions) {
  const { onBeat, type = 'delay', interval, enabled = true } = options;

  const fnRef = useRef<BeatFn>(onBeat);
  useEffect(() => {
    let timer: any = null;
    let index = 0;
    let startTime: number = 0;
    function loop() {
      const fn = fnRef.current;

      const duration = Date.now() - startTime;
      const promise = fn?.(index, duration);
      index++;
      // const remaining =
      promise.then(() => {
        timer = setTimeout(() => {
          loop();
        }, interval);
      });
    }
    function start() {
      startTime = Date.now();
      loop();
    }

    if (enabled) {
      start();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [enabled, type, interval]);
}
